import trackingApi from '~/api/tracking'
import accessControl from '~/utilities/accessControl'
import userState from '~/states/user'
import utils from '~/utilities/utils'
import userApi from '~/api/user'
import config from '~/config'
import apiBase from '~/api/base'

const methodsMixins = {
  methods: {
    async checkAccess(entityId, link, trackingAction, target) {
      const instance = this.$store.getters['instancesState/getInstance']
      const user = userState.getUser(instance)
      let linkToCheck = ''
      if (!utils.isUrl(link)) {
        linkToCheck = link === 'search' ? `/${instance}/${this.$route.params.event}/${this.$route.params.language}/${link}` : `/${link}/${instance}/${this.$route.params.event}/${this.$route.params.language}`
      }

      this.hasAccess = user ? accessControl.accessControlUrl(linkToCheck) : false

      if (this.hasAccess) {
        trackingApi.trackCustomAction(
          trackingAction,
          entityId,
          this.$route.name,
        )
        window.open(linkToCheck, target)
      } else {
        this.onAccessDeniedDialogClose = true
      }
    },
    async openUrl(entityId, link, trackingAction = 'vmx-openurl', target = '_self') {
      this.checkAccess(entityId, link, trackingAction, target)
    },
    async logout(trackingCallback = null) {
      const instance = this.$store.getters['instancesState/getInstance']
      const backendConfig = this.$store.getters['config/configForKey']('app_config')?.config?.[0]

      // Track logout action if callback is provided
      if (trackingCallback && typeof trackingCallback === 'function') {
        trackingCallback('logout')
      }

      // Remove cookies
      this.$cookies.remove('accesOnDays')
      this.$cookies.remove('tickets')
      this.$cookies.remove('hcp')

      // Clear user state
      userState.unsetUser(instance)
      this.$store.commit('instancesState/setToken', null)

      // Clear localStorage items
      localStorage.removeItem('externalLogin')
      localStorage.removeItem('recheckedUserTicket')

      // Handle SignalR if available
      if (userApi.blockUser && typeof userApi.blockUser === 'function') {
        try {
          await userApi.blockUser()
        } catch (error) {
          console.warn('Error blocking user:', error)
        }
      }

      // Check for external auth logout
      if (backendConfig?.defaults?.externalAuth?.logoutUrl) {
        window.location.href = backendConfig.defaults.externalAuth.logoutUrl
        return
      }

      // Default logout redirect
      const webFormsUrl = config.getInstanceConfig(instance).identityUrl
      const logoutUrl = '/api/Token/LougoutFromBody'
      const page = backendConfig?.defaults?.logoutSettings?.page || 'home'
      const event = this.$route.params?.event || ''
      const language = this.$route.params?.language || ''
      const returnUrl = backendConfig?.defaults?.logoutSettings?.returnUrl || `${window.location.origin}/${page}/${instance}/${event}/${language}`
      const validateLogoutUrl = `${webFormsUrl}${logoutUrl}?returnUrl=${encodeURIComponent(returnUrl)}`
      const response = await apiBase.post(validateLogoutUrl)
      if (response?.status === 200) {
        window.location.href = response.data.redirectUrl
        // Handle successful logout
      }
    },
  },
}
export default methodsMixins